import { useQuery } from '@tanstack/react-query';

import { orderTrackingService } from '@/services/orderTracking/orderTracking.service';
import type { OrderTrackingDashboardData } from '@/services/orderTracking/orderTracking.types';

/** Cache en cliente: al volver al módulo no se espera de nuevo al API salvo refresh manual o stale. */
const STALE_MS = 5 * 60 * 1000;
const GC_MS = 30 * 60 * 1000;

export function orderTrackingDashboardQueryKey(
  warehouseId: number | null | undefined,
  orderDateFrom?: string,
  orderDateTo?: string
) {
  return [
    'order-tracking-dashboard',
    warehouseId ?? 'all',
    orderDateFrom || null,
    orderDateTo || null,
  ] as const;
}

export function useOrderTrackingDashboard(
  warehouseId: number | null | undefined,
  options?: { orderDateFrom?: string; orderDateTo?: string }
) {
  const orderDateFrom = options?.orderDateFrom || undefined;
  const orderDateTo = options?.orderDateTo || undefined;

  return useQuery<OrderTrackingDashboardData>({
    queryKey: orderTrackingDashboardQueryKey(warehouseId, orderDateFrom, orderDateTo),
    queryFn: () =>
      orderTrackingService.getDashboardData({
        ...(warehouseId != null ? { warehouse_id: warehouseId } : {}),
        ...(orderDateFrom ? { order_date_from: orderDateFrom } : {}),
        ...(orderDateTo ? { order_date_to: orderDateTo } : {}),
      }),
    staleTime: STALE_MS,
    gcTime: GC_MS,
    placeholderData: (previous) => previous,
  });
}
